import React, { Component } from 'react';
import WhatsAppButton from '../../WhatsAppButton.jsx';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            course: '',
            message: '',
            success: false,
            error: false
        };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        const { name, email, course, message } = this.state;
        const time = new Date().toLocaleString();

        // Construimos el HTML con los valores del formulario
        const htmlMessage = `
        <div style="font-family: system-ui, sans-serif, Arial; font-size: 12px;">
          <div>
            Has recibido un nuevo mensaje de <strong>${name}</strong> sobre el curso
            <strong>${course}</strong>. Responde a la mayor brevedad posible.
          </div>
          <div style="margin-top: 20px; padding: 15px 0; border-width: 1px 0; border-style: dashed; border-color: lightgrey;">
            <table role="presentation">
              <tr>
                <td style="vertical-align: top;">
                  <div style="padding: 6px 10px; margin: 0 10px; background-color: aliceblue; border-radius: 5px; font-size: 26px;" role="img">👤</div>
                </td>
                <td style="vertical-align: top;">
                  <div style="color: #2c3e50; font-size: 16px;"><strong>${name}</strong></div>
                  <div style="color: #7f8c8d; font-size: 13px;">📧 ${email}</div>
                  <div style="color: #7f8c8d; font-size: 13px;">🎓 ${course}</div>
                  <div style="color: #cccccc; font-size: 13px;">${time}</div>
                  <div style="margin-top: 10px; font-size: 16px; color: #2c3e50;">${message}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        `;

        
        // Definir la base URL según el hostname
            const BASE_URL =
              window.location.hostname === 'neuralnetadaptivecontrol.com'
                ? 'https://controlbook.onrender.com'
                : 'http://localhost:3000';
        // save data and send welcoing email
            try {
             const result = await fetch(`${BASE_URL}/emails/send`, {
               method: 'POST',
               headers: { 'Content-Type': 'application/json' },
               body: JSON.stringify({
                 name,
                 to: email,
                 course,
                 message
               })
            });
            if (result.ok) {
                this.setState({ success: true, error: false, name: '', email: '', message: '', course: '' });
            } else {
                this.setState({ success: false, error: true });
            }
        } catch (error) {
            console.error('Error during unsubscription:', error);
            this.setState({ success: false, error: true });
        }
    }

    render() {
        return (
            <section className="section-padding contact dark-bg" id="contact">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">Contact for the course information</h3>
                                <p>This course is a must for professionals interested in control systems</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-sm-12 col-md-12">
                            {this.state.success && (
                                <div className="alert alert-success" role="alert">
                                    Your message was sent successfully.
                                </div>
                            )}
                            {this.state.error && (
                                <div className="alert alert-danger" role="alert">
                                    There was an error sending your message. Please try again.
                                </div>
                            )}
                            <form className="contact__form form-row contact-form" onSubmit={this.handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                className="form-control"
                                                placeholder="Enter Your Name"
                                                value={this.state.name}
                                                onChange={this.handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                className="form-control"
                                                placeholder="Enter Your Email Address"
                                                value={this.state.email}
                                                onChange={this.handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <select
                                                name="course"
                                                className="form-control"
                                                value={this.state.course}
                                                onChange={this.handleChange}
                                                required
                                            >
                                                <option value="" disabled>Select The Course</option>
                                                <option value="Curso en Control de Sistemas">Curso en Control de Sistemas</option>
                                                <option value="Curso en Identificación de Sistemas">Curso en Identificación de Sistemas</option>
                                                <option value="Control System Course (english)">Control System Course (english)</option>
                                                <option value="System Identification Course (english)">System Identification course (english)</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <textarea
                                                id="message"
                                                name="message"
                                                cols="30"
                                                rows="6"
                                                className="form-control"
                                                placeholder="Your Message"
                                                value={this.state.message}
                                                onChange={this.handleChange}
                                                required
                                            ></textarea>    
                                        </div>
                                    </div>
                                    <div className="d-lg-flex justify-content-between mt-4">
                                      <p>* Rest assured. We will not spam your inbox.</p>
                                      <input
                                        id="submit"
                                        name="submit"
                                        type="submit"
                                        className="btn btn-main-2"
                                        value="Send Message"
                                      />
                                    </div>
                                </div>
                            </form> 
                        </div>
                    </div>
                </div>
                {/* 👇 Botón flotante de WhatsApp */}
                <div style={{ position: 'fixed', bottom: '0.5rem', right: '0.05rem', zIndex: 50 }}>
                    <WhatsAppButton />
                </div>
            </section>
        );
    }
}

export default Contact;